import ko from "knockout";
import { defaultLanguage } from "./translations";

function updateUrl() {
  const value = getRouteInternal(window.location.pathname).url;

  if (value === "/404" && value !== window.location.pathname) {
    if ("undefined" !== typeof history.pushState) {
      history.replaceState({ page: "" }, "404", value);
    } else {
      window.location.replace(value);
    }
  }

  return value;
}

const init = () => {
  const url = ko.observable(updateUrl());

  window.addEventListener("hashchange", () => url(updateUrl()));
  window.addEventListener("locationchange", () => url(updateUrl()));
  window.addEventListener("popstate", () => url(updateUrl()));

  return url;
};

const routes = [
  {
    url: "/",
    title: "Start",
  },
  {
    url: "/introduction",
    title: "Introduction",
  },
  {
    url: "/introductie",
    title: "Introductie",
  },
  {
    url: "/storyline",
    title: "Storyline",
  },
  {
    url: "/verhaallijn",
    title: "Verhaallijn",
  },
  {
    url: "/database",
    title: "Database",
  },
  {
    url: "/databank",
    title: "Databank",
  },
];

function getRouteInternal(routeUrl) {
  return [
    ...routes.filter(({ url }) => url === routeUrl),
    {
      url: "/404",
      title: "404",
    },
  ][0];
}

export const pushRoute = (routeUrl, obsUrl) => {
  if ("undefined" !== typeof history.pushState) {
    history.pushState({ page: "page" }, "title", routeUrl);
    obsUrl(updateUrl());
  } else {
    window.location.assign(routeUrl);
  }
};

export function getTitle(routeUrl) {
  return [...routes.filter(({ url }) => url === routeUrl), { title: "404" }][0]
    .title;
}

const pages = {
  introduction: {
    nl: "/introductie",
    en: "/introduction",
  },
  storyline: {
    nl: "/verhaallijn",
    en: "/storyline",
  },
  database: {
    nl: "/databank",
    en: "/database",
  },
};

export const r = (key) => {
  if (!pages[key] && process.env.DEBUG) {
    console.log("missing page");
  } else {
    if (process.env?.LANGUAGE === "") {
      return pages[key][defaultLanguage];
    } else {
      return pages[key][process.env.LANGUAGE];
    }
  }
};

export default init;
